import { Link } from 'react-router-dom';

export interface GameMeta {
  num: string;
  title: string;
  desc: string;
  info: string;
  to: string;
  featured?: boolean;
  badge?: string;
}

export function GameCard({ game }: { game: GameMeta }) {
  return (
    <Link to={game.to} className={`card${game.featured ? ' featured' : ''}`}>
      <div className="top">
        <span className="num">{game.num}</span>
        {game.badge ? <span className="badge">{game.badge}</span> : null}
      </div>
      <div>
        <h3>{game.title}</h3>
        <div className="desc">{game.desc}</div>
      </div>
      <div>
        <div className="rule" />
        <div className="meta">
          <span className="info">{game.info}</span>
          <span className="go">Играть →</span>
        </div>
      </div>
      <div className="hover-line" />
      <style>{`
        .card { position: relative; display: flex; flex-direction: column; justify-content: space-between;
          background: var(--bg2); border: 1px solid var(--line); border-radius: var(--radius-card);
          padding: 24px; min-height: 250px; overflow: hidden; transition: background .25s, border-color .25s;
          cursor: pointer; text-decoration: none; color: inherit; }
        .card:hover { background: var(--bg3); border-color: var(--line-strong); }
        .card .num { font-family: 'JetBrains Mono', monospace; font-size: 11px; color: var(--ink-faint); letter-spacing: .16em; }
        .card .top { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px; }
        .card .badge { font-family: 'JetBrains Mono', monospace; font-size: 10px; background: var(--accent); color: var(--accent-ink); padding: 4px 8px; letter-spacing: .12em; border-radius: 3px; text-transform: uppercase; }
        .card h3 { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 32px; line-height: 1; letter-spacing: -.005em; margin: 0 0 10px; }
        .card .desc { font-size: 13px; color: var(--ink-dim); line-height: 1.5; max-width: 300px; }
        .card .rule { height: 1px; background: var(--line); margin: 20px 0 14px; }
        .card .meta { display: flex; justify-content: space-between; align-items: center; }
        .card .info { font-family: 'JetBrains Mono', monospace; font-size: 11px; color: var(--ink-dim); letter-spacing: .08em; white-space: nowrap; }
        .card .go { font-family: 'JetBrains Mono', monospace; font-size: 11px; color: var(--ink); letter-spacing: .12em; white-space: nowrap; }
        .card .hover-line { position: absolute; bottom: 0; left: 0; right: 0; height: 2px; background: var(--accent); transform: translateX(-101%); transition: transform .45s cubic-bezier(.2,.8,.2,1); }
        .card:hover .hover-line { transform: translateX(0); }
        .card.featured { grid-column: span 2; padding: 32px; min-height: 300px; }
        .card.featured h3 { font-size: 56px; }
        .card.featured .desc { font-size: 15px; max-width: 380px; }
      `}</style>
    </Link>
  );
}
